import React from 'react';
import PropTypes from 'prop-types';
import DateRangePicker from 'components/input/DateRange/DateRangePicker';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const DateRangeInput = (props) => {
    const {
        defaultValue,
        floatingLabelFixed,
        input,
        label,
        onAccept,
        placeholder,
        translate,
        ...restProps
    } = props;

    // First we will transform the string into an array of values.
    if (utils.isString(input.value)) {
        const [
            first,
            second,
        ] = input.value.split('~');

        input.value = [
            first || defaultValue[0],
            second || defaultValue[1],
        ];
    }

    utils.map(input.value, (val) => {
        if (utils.isDate(val)) {
            return val;
        }

        return new Date(val);
    });

    return (
        <DateRangePicker
            { ...input }
            { ...restProps }
            floatingLabelFixed={ floatingLabelFixed }
            floatingLabelText={ label ? translate(label) : null }
            fullWidth={ true }
            hintText={ placeholder ? translate(placeholder) : null }
            onAccept={ onAccept }
        />
    );
};

DateRangeInput.propTypes = {
    defaultValue: PropTypes.array,
    floatingLabelFixed: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        onDrop: PropTypes.func,
        onFocus: PropTypes.func,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
        ]),
    }),
    label: PropTypes.string,
    onAccept: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default translate(DateRangeInput);


// WEBPACK FOOTER //
// ./src/components/input/DateRange/DateRangeInput.js